import * as styles from "./ExternalSignPostCard.module.scss";

import cx from "classnames";
import React from "react";
import ProcessedImage from "../../common/ProcessedImage/ProcessedImage";
import StandardSignPostCard from "../StandardSignPostCard";

export const ExternalSignPostCard: React.FC<
	DogsTrust.SignPostCardProps & { useStandardCard?: boolean }
> = (props) => {
	const {
		title,
		body,
		buttonLabel,
		externalUrl,
		imgAlt,
		imgSrc,
		useStandardCard,
	} = props;
	if (useStandardCard) {
		return <StandardSignPostCard {...props} />;
	}
	return (
		<div
			className={cx({
				[styles.cardwrapperwithimage]: imgSrc.length > 0,
				[styles.cardwrapper]: imgSrc.length === 0,
			})}
		>
			<div className={styles.cardimage}>
				<ProcessedImage src={imgSrc} alt={imgAlt} dimensions="200x200" />
			</div>
			<h2 data-variation="hideFromJumpLinks" className={styles.title}>
				{title}
			</h2>
			<p className={styles.cardsubtitletext}>{body}</p>
			<div className={styles.linkwrapper}>
				<a href={externalUrl}>{buttonLabel}</a>
			</div>
		</div>
	);
};

export default ExternalSignPostCard;
